import VueI18n from 'vue-i18n';

export function paginationOptions($i18n: VueI18n) {
    return {
        enabled: true,
        nextLabel: $i18n.t('txtNext'),
        prevLabel: $i18n.t('txtPrev'),
        rowsPerPageLabel: $i18n.t('txtPagePer'),
        ofLabel: $i18n.t('txtOf'),
        pageLabel: $i18n.t('txtPage'),
        allLabel: $i18n.t('txtAll'),
    };
}

export function searchOptions($i18n: VueI18n) {
    return {
        enabled: true,
        placeholder: $i18n.t('txtFilter'),
    };
}

export function selectOptions($i18n: VueI18n) {
    return {
        enabled: true,
        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
        selectionText: $i18n.t('comSelectionCnt').toString(),
        clearSelectionText: $i18n.t('comClear').toString(),
        disableSelectInfo: false, // disable the select info panel on top
        selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
    };
}